import axios from 'axios';

import { ConfiguratorConfigData, ConfiguratorConfigResponse, Maybe } from '../types';

let cached: Maybe<Promise<ConfiguratorConfigData>>;

export function requestConfiguratorConfig(): Promise<ConfiguratorConfigData> {
  if (cached) {
    return cached;
  }

  cached = new Promise((resolve) => {
    axios
      .get<ConfiguratorConfigResponse>(
        `${window.config.templatizationConfigApiUrl}/config-api/configurator-config/list?cid=4209e5ce-5b5f-4c4b-93e9-dc2d2e441a55`,
      )
      .then((response) => {
        if (response.data.success) {
          resolve(response.data.data);
        } else {
          resolve({
            designVariants: [],
          });
        }
      });
  });

  return cached;
}
